// -----------------------------------------------------------------------------
// src/routes/CreatorConnectRoute.jsx — drawer margin now FROM THE LEFT on desktop
// -----------------------------------------------------------------------------
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import CreatorHeader from './CreatorHeader';
import {
  Box,
  CssBaseline,
  IconButton,
  ThemeProvider,
  Toolbar,
  Badge,
} from '@mui/material';
import { lightTheme } from '../Utils/baseTheme';
import CreatorNavbar from './CreatorNavbar';
import useIsDesktop from '../Hooks/useIsDesktop';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import { drawerWidth } from '../Utils/constants';

/* ------------------------------------------------------------------ */
/* Drawer‑aware content sizing */
/* ------------------------------------------------------------------ */
const openedMixin = (theme) => ({
  width: { xs: '100%', md: `calc(100% - ${drawerWidth})` },
  ml: { xs: 0, md: drawerWidth }, // margin‑left on desktop
  transition: theme.transitions.create(['width', 'margin-left'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
});

const closedMixin = (theme) => ({
  width: { xs: '100%', md: `calc(100% - ${theme.spacing(8)} + 1px)` },
  ml: { xs: 0, md: `calc(${theme.spacing(8)} - 1px)` },
  transition: theme.transitions.create(['width', 'margin-left'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
});

const CreatorConnectRoute = () => {
  const isDesktop = useIsDesktop();
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [mobileActions, setMobileActions] = useState([]);
  const isExtended = !isDesktop || isOpen;

  const handleUnreadCountChange = (count) => setUnreadCount(count);
  const handleGetMobileActions = (actions) => setMobileActions(actions);

  /* ---------- menu button (desktop only) ---------- */
  const MenuButton = isDesktop ? (
    <IconButton
      edge="start"
      aria-label="menu"
      sx={{ mr: 2 }}
      onClick={() => setIsOpen((prev) => !prev)}
    >
      {isOpen ? (
        /* desktop collapse arrow */
        <KeyboardArrowLeftSharpIcon sx={{ color: '#fff' }} />
      ) : (
        /* desktop expand arrow */
        <KeyboardArrowRightSharpIcon sx={{ color: '#fff' }} />
      )}
    </IconButton>
  ) : null;

  return (
    <ThemeProvider theme={lightTheme}>
      <CreatorNavbar
        isDesktop={isDesktop}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onUnreadCountChange={handleUnreadCountChange}
        onGetMobileActions={handleGetMobileActions}
      />
      <CssBaseline />
      {/* Pass `isDesktop` and `mobileActions` for mobile header */}
      <CreatorHeader 
        menuIcon={MenuButton} 
        isDesktop={isDesktop} 
        mobileActions={mobileActions} 
      />
      {/* Reserve header space */}
<Toolbar sx={{ display: { xs: 'flex', md: 6 } }} />      {/* Page container reacts to drawer size */}
      <Box 
        id="TopPageContainer" 
        sx={(theme) => (isExtended ? openedMixin(theme) : closedMixin(theme))}
      >
        <Outlet />
      </Box>
    </ThemeProvider>
  );
};

export default CreatorConnectRoute;